import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileDragDropComponent } from './file-drag-drop.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { ObserversModule } from '@angular/cdk/observers';



@NgModule({
  declarations: [
    FileDragDropComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    ObserversModule,
    MatButtonModule,
    MatDividerModule
  ],
  exports: [
    FileDragDropComponent
  ]
})
export class FileDragDropModule { }
